import { SET_AVISO_AUTOCHECK } from "../ActionTypes";

const avisoAutocheck = (state, { payload, type }) => {
  switch (type) {
    case SET_AVISO_AUTOCHECK:
      return {
        ...state,
        avisoAutocheck: {
          show: payload,
        },
      };

    default:
      return state;
  }
};

export default avisoAutocheck;
